export const getColabServerUrl = () => {
    let API_URL = "";
    if (window.location.hostname === "localhost") {
        API_URL = "localhost:6969";
    } else if (window.location.hostname === "editor.riders.ai") {
        API_URL = "api.riders.ai";
    } else if (window.location.hostname === "editor-staging.riders.ai") {
        API_URL = "api-staging.riders.ai";
    }

    return API_URL;
}

export const getRidersLoginUrl = () => {
    let LOGIN_URL = "";
    if (window.location.hostname === "editor.riders.ai") {
        LOGIN_URL = "riders.ai";
    } else if (window.location.hostname === "editor-staging.riders.ai") {
        LOGIN_URL = "staging.riders.ai";
    }

    return LOGIN_URL;
}